import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_DEM_TEMPLATE_STATE,
});

export const syncDemTemplates = () => ({
  type: types.SYNC_DEM_TEMPLATES.REQUEST,
});

export const syncDemTemplatesSuccess = (demTemplates) => ({
  type: types.SYNC_DEM_TEMPLATES.SUCCESS,
  demTemplates,
});

export const syncDemTemplatesFailure = (error) => ({
  type: types.SYNC_DEM_TEMPLATES.FAILURE,
  error,
});

export const fetchDemTemplate = (templateId) => ({
  type: types.FETCH_DEM_TEMPLATE.REQUEST,
  templateId,
});

export const fetchDemTemplateSuccess = (template) => ({
  type: types.FETCH_DEM_TEMPLATE.SUCCESS,
  template,
});

export const fetchDemTemplateFailure = (error) => ({
  type: types.FETCH_DEM_TEMPLATE.FAILURE,
  error,
});

export const createDemTemplate = (template) => ({
  type: types.CREATE_DEM_TEMPLATE.REQUEST,
  template,
});

export const createDemTemplateSuccess = () => ({
  type: types.CREATE_DEM_TEMPLATE.SUCCESS,
});

export const createDemTemplateFailure = (error) => ({
  type: types.CREATE_DEM_TEMPLATE.FAILURE,
  error,
});

export const updateDemTemplate = (template) => ({
  type: types.UPDATE_DEM_TEMPLATE.REQUEST,
  template,
});

export const updateDemTemplateSuccess = () => ({
  type: types.UPDATE_DEM_TEMPLATE.SUCCESS,
});

export const updateDemTemplateFailure = (error) => ({
  type: types.UPDATE_DEM_TEMPLATE.FAILURE,
  error,
});

export const duplicateDemTemplate = (templateId) => ({
  type: types.DUPLICATE_DEM_TEMPLATE.REQUEST,
  templateId,
});

export const duplicateDemTemplateSuccess = () => ({
  type: types.DUPLICATE_DEM_TEMPLATE.SUCCESS,
});

export const duplicateDemTemplateFailure = (error) => ({
  type: types.DUPLICATE_DEM_TEMPLATE.FAILURE,
  error,
});

export const archiveDemTemplate = (templateId) => ({
  type: types.ARCHIVE_DEM_TEMPLATE.REQUEST,
  templateId,
});

export const archiveDemTemplateSuccess = () => ({
  type: types.ARCHIVE_DEM_TEMPLATE.SUCCESS,
});

export const archiveDemTemplateFailure = (error) => ({
  type: types.ARCHIVE_DEM_TEMPLATE.FAILURE,
  error,
});

export const generateAiDemTemplate = ({ prompt, currentDesign }) => ({
  type: types.GENERATE_AI_DEM_TEMPLATE.REQUEST,
  prompt,
  currentDesign,
});

export const generateAiDemTemplateSuccess = ({
  message,
  design,
  designSnapshotBefore,
}) => ({
  type: types.GENERATE_AI_DEM_TEMPLATE.SUCCESS,
  message,
  design,
  designSnapshotBefore,
});

export const generateAiDemTemplateFailure = (error) => ({
  type: types.GENERATE_AI_DEM_TEMPLATE.FAILURE,
  error,
});

export const toggleAiPanel = () => ({ type: types.TOGGLE_AI_PANEL });

export const resetAiConversation = () => ({ type: types.RESET_AI_CONVERSATION });

export const undoLastAiDesign = (messageId) => ({
  type: types.UNDO_LAST_AI_DESIGN,
  messageId,
});
